<template>
  <Wrapper pageIcon="newsletters">
    <form v-on:submit.prevent="saveSubscriptions">
      <FieldWrapper>
        <div slot="input">
          <switches
            :value="user.subscribed"
            @input="update"
            label="I want to receive newsletters and promotional materials"
            theme="bulma"
            type-bold="true"
            color="green"
            v-validate="'boolean'"
            data-vv-scope="subscriptions"
          />
          <Divider />
        </div>
        <DecoratedButton
          slot="button"
          name="save"
          type="submit"
          :loading="loading"
        >
          UPDATE SUBSCRIPTION PREFERENCES
        </DecoratedButton>
      </FieldWrapper>
    </form>
  </Wrapper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Wrapper from "@/components/partials/profile/Wrapper";
import Switches from "@/components/partials/Switch";

export default {
  name: "form-profile-subscriptions",
  components: { Wrapper, Switches },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      loading: "getLoading"
    }),
    isFormDirty() {
      return Object.keys(this.fields.$subscriptions).some(
        key => this.fields.$subscriptions[key].dirty
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      if (
        confirm(
          "You have some unsaved changes, are you sure you want to continue?"
        ) == true
      ) {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    ...mapActions("user", {
      updateUserAttribute: "updateUserAttribute",
      saveUserAttribute: "saveUserAttribute"
    }),
    resetForm() {
      Object.keys(this.fields.$subscriptions).some(
        key => (this.fields.$subscriptions[key].dirty = false)
      );
    },
    update(val) {
      this.updateUserAttribute({
        attribute: "subscribed",
        value: val
      });
    },
    saveSubscriptions() {
      this.$validator.validateAll("subscriptions").then(valid => {
        if (valid) {
          this.saveUserAttribute({
            subscribed: this.user.subscribed
          });
          this.resetForm();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  min-width: 400px;
}
</style>
